import { KrCard } from '@/common/card/KrCard';
import { Grid } from '@/common/grid/Grid';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { useEffect, useRef, useState } from 'react';

export const DirSaleLineTopCtrtCard = ({ formValues, totalProdIds }) => {
  const rsrc = useRsrc();
  const gridRef = useRef();

  const [data, setData] = useState([]);
  const [fieldDefs] = useState([
    { field: 'name', displayName: 'Contract' },
    { field: 'code', displayName: 'Code', module: 'md', entity: 'CTRT', type: 'HYPERLINK' },
    { field: 'salesAmt', displayName: 'Gross Sales Amount', type: 'MONEY', sort: 'desc' },
    { field: 'priorSalesAmt', displayName: 'Prior Year', type: 'MONEY' },
    { field: 'salesChange', displayName: 'YoY Change', type: 'MONEY' },
    { field: 'salesGrowth', displayName: 'YoY %', type: 'PERCENT', decimalPrecision: 2 },
  ]);
  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    if (!formValues?.invPeriodId) {
      return;
    }

    const prodFilter = TreeUtils.smallestIdFilter(formValues.prodIds, totalProdIds);

    const reqParam = {
      invPeriodId: formValues.invPeriodId,
      prodIds: prodFilter.ids,
      prodIdsNot: prodFilter.not,
    };

    rsrc.data('sc', 'DIR_SALE_LINE_TOP_CTRT_GRID_DATA_PLUGIN', reqParam).then((res) => {
      setData(res);
    });
  }, [formValues?.invPeriodId, formValues?.prodIds, totalProdIds]);

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
      gridRef.current.setDataSource(data);
    }
  }, [isGridReady, data]);

  return (
    <KrCard title="Top Contracts">
      <Grid
        ref={gridRef}
        gridOptions={{
          fieldDefs,
          rowModelType: 'clientSide',
          statusBar: null,
        }}
        events={{
          onGridReady: () => setIsGridReady(true),
        }}
      />
    </KrCard>
  );
};
